<div
  class="canvas-chat-container"
  id="canvas_chat_container"
  [ngClass]="{
    'canvas-chat-container-collapsed': hubService.isContentEditorOpened
  }"
>
  <div class="canvas-chat-header">
    <div class="canvas-chat-title">
      <img
        src="../../../../assets/icons/svg/chat-drawer.svg"
        alt="Drawer"
        id="sidebar_icon"
        class="action-icon"
        height="25"
        (click)="hubService.toggleDrawer()"
        width="25"
        (keydown)="hubService.toggleDrawer()"
      />
      EY Impact.AI
    </div>

    <div class="canvas-chat-action-container">
      <img
        class="canvas-chat-action-button action-icon"
        *ngIf="
          hubService.currentChatMessages.length && hubService.isAgentWorking()
        "
        src="../../../../assets/icons/svg/stop-blue.svg"
        alt="cost"
        height="28"
        width="28"
        (click)="hubService.stopAgentWorking()"
        (keydown)="hubService.stopAgentWorking()"
      />

      <img
        class="canvas-chat-action-button action-icon"
        *ngIf="hubService.currentChatMessages.length"
        src="../../../../assets/icons/svg/chat-cost.svg"
        alt="cost"
        height="28"
        width="28"
        matTooltipPosition="below"
        [matTooltipClass]="['header-saved-search-item-theme']"
        matTooltip="{{ getTotalUsageCost() }}"
      />
      <div
        [ngClass]="{ 'd-none': hubService.isContentEditorOpened }"
        class="d-flex gap-3 align-items-center"
      >
        <div
          *ngIf="hubService.anyHavingBookmarks()"
          class="bookmarks-wrapper canvas-chat-action-button action-icon"
          (click)="
            hubService.incrementBookmarkIndex();
            hubService.triggerConversationNavigation()
          "
          (keydown)="
            hubService.incrementBookmarkIndex();
            hubService.triggerConversationNavigation()
          "
        >
          {{ hubService.getBookmarksCounterString() }}
          <img
            src="../../../../assets/icons/svg/bookmark-chat-selection.svg"
            alt="Bookmarked"
            height="20"
            width="25"
          />
        </div>

        <img
          *ngIf="hubService.isEmbededChat"
          src="../../../../assets/icons/svg/chat-expand.svg"
          alt="Expand"
          height="30"
          width="32"
          (click)="expandChat()"
          class="canvas-chat-action-button action-icon"
          id="expand_icon"
          (keydown)="expandChat()"
        />

        <img
          src="../../../../assets/icons/svg/chat-info.svg"
          alt="Drawer"
          height="25"
          width="25"
          (click)="openChatInfo()"
          class="canvas-chat-action-button action-icon"
          (keydown)="openChatInfo()"
        />

        <img
          src="../../../../assets/icons/svg/x-circle.svg"
          alt="Drawer"
          height="32"
          width="32"
          class="canvas-chat-action-button action-icon"
          (click)="closeChat()"
          (keydown)="closeChat()"
        />
      </div>
    </div>
  </div>

  <div
    class="chat-section"
    [ngClass]="{
      'chat-section-collapsed': hubService.isContentEditorOpened
    }"
  >
    <div class="chat-container">
      <div
        class="chat-overlay"
        *ngIf="
          hubService.currentChatMessages.length === 0 &&
          isLoadingChatConversations
        "
      >
        <div class="spinner-overlay">
          <mat-progress-spinner
            class="progress-chat"
            [color]="'primary'"
            [mode]="'indeterminate'"
          >
          </mat-progress-spinner>
          <p>Loading conversation...</p>
        </div>
      </div>
      <div
        class="chat-overview"
        [ngClass]="{
          'chat-overview-collapsed': hubService.isContentEditorOpened,
          'overflow-hidden':
            hubService.currentChatMessages.length === 0 &&
            !isLoadingChatConversations
        }"
      >
        <ng-container
          *ngIf="
            hubService.currentChatMessages.length === 0 &&
            !isLoadingChatConversations
          "
        >
          <app-chat-introduction
            class="h-100"
            [isEmbededChat]="hubService.isEmbededChat"
          ></app-chat-introduction>
        </ng-container>

        <div
          class="chat scrollbar-custom-scroll-style"
          [ngClass]="{
            'chat-collapsed': hubService.isContentEditorOpened
          }"
        >
          <app-canvas-chat-item
            *ngFor="
              let chat of hubService.currentChatMessages;
              let i = index;
              trackBy: trackById
            "
            id="chat-{{ chat._id }}"
            [chatItem]="chat"
            [isEmbededChat]="isEmbededChat"
            [responseCount]="chat?.responses?.length"
            [userEmail]="hubService.currentUserEmail"
            [isLastConversation]="
              i === hubService.currentChatMessages.length - 1
            "
            class="bookmarked-chat"
          ></app-canvas-chat-item>

          <app-canvas-loader
            id="chat-loader-ui"
            *ngIf="
              !isLoadingChatConversations &&
              hubService.isAgentWorking(hubService.currentSessionId)
            "
            [loaderType]="loaderTypes.TYPING"
          />
        </div>
      </div>
      <div
        class="foot-section"
        [class.disabled]="
          hubService.isAgentWorking() ||
          (hubService.currentChatMessages.length === 0 &&
            isLoadingChatConversations)
        "
        [ngClass]="{
          'foot-section-collapsed': hubService.isContentEditorOpened,
          'd-none': hubService.isSessionReadOnly
        }"
      >
        <div
          class="button-box w-100 d-flex align-items-start justify-content-center"
          id="impact_textbox"
        >
          <textarea
            type="text"
            class="input-bo"
            rows="3"
            placeholder="Ask EY Impact.AI"
            (keydown.enter)="sendMessage()"
            (keyup.enter)="userText = ''"
            [(ngModel)]="userText"
          ></textarea>
        </div>
        <div
          class="send-button-box w-100 d-flex align-items-center justify-content-between"
        >
          <img
            class="action-icon cursor-pointer"
            id="newchat_icon"
            src="../../../../assets/icons/svg/new-chat.svg"
            alt="New Chat"
            height="23"
            width="23"
            (click)="hubService.newChatSession()"
            (keydown)="hubService.newChatSession()"
          />

          <div class="d-flex align-items-center justify-content-center gap-3">
            <input
              class="file-selector"
              type="file"
              (change)="onFileSelected($event)"
              (click)="handleFileInputClick($event)"
              accept="{{ acceptedFiles }}"
              multiple
              #file
            />

            <img
              class="action-icon cursor-pointer"
              id="attachfile_icon"
              src="../../../../assets/icons/svg/paper-clip.svg"
              alt="Attach"
              height="23"
              width="23"
              (click)="file.click()"
              (keydown)="file.click()"
            />

            <img
              class="action-icon cursor-pointer"
              id="send_icon"
              src="../../../../assets/icons/svg/send-icon.svg"
              alt="Send"
              height="23"
              width="23"
              (click)="sendMessage()"
              (keydown)="sendMessage()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="chat-footer" *ngIf="!hubService.isContentEditorOpened">
    <span class="m-0" *ngIf="!hubService.isEmbededChat">
      This AI chatbot provides automated responses and may not always be
      accurate!
    </span>
    <span class="instance">{{ hubService.currentSessionId }}</span>
  </div>
</div>
